import { render, staticRenderFns } from "./NotificationsItemBase.vue?vue&type=template&id=575ac822&scoped=true&"
import script from "./NotificationsItemBase.vue?vue&type=script&lang=js&"
export * from "./NotificationsItemBase.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsItemBase.vue?vue&type=style&index=0&id=575ac822&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575ac822",
  null
  
)

export default component.exports